import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class TrackOrder extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <PageBanner title='Track Your Order' background='page-banner.jpg' />
        <div className='p-5'>
          <div className='row justify-content-center'>
            <div className='col-md-6'>
              <h3 className='mb-4'>Track Your Order</h3>
              <p>
                Enter your order number and email address below to check the
                status of your order.
              </p>
              <form>
                <div className='form-group mb-3'>
                  <label htmlFor='orderNumber'>Order Number</label>
                  <input
                    type='text'
                    className='form-control'
                    id='orderNumber'
                    placeholder='Enter your order number'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>Email Address</label>
                  <input
                    type='email'
                    className='form-control'
                    id='email'
                    placeholder='Enter your email address'
                  />
                </div>
                <button
                  type='submit'
                  className='btn'
                  style={{
                    background: '#2563eb',
                    color: '#fff',
                    fontWeight: 'bold',
                    padding: '10px 30px',
                    borderRadius: '8px',
                  }}
                >
                  Track Order
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default TrackOrder;
